const ADD_POST = 'ADD_POST';
const UPDATE_NEW_POST_TEXT = 'UPDATE_NEW_POST_TEXT';

let initialState =  {
    posts: [
        {
            id: 1,
            name: "Tommy Shelby",
            published: "September,15 2022 19:PM",
            imgURL: "https://i2-prod.liverpoolecho.co.uk/incoming/article23503282.ece/ALTERNATES/s1200c/1_Peaky-Blinders.jpg",
            video: "",
            imgRandom: "https://miro.medium.com/max/800/0*JUUIaKYvIBQq9p9y.jpg",
            message: "Hi, everyone! Check out my latest travel pics.Likes and shares appreciated. Cheers!",
            likeCount: "12"
        },
        {
            id: 2,
            name: "Beth Harmon",
            published: "October,10 2022 17:PM",
            imgURL: "https://wallpapers.com/images/high/the-queen-s-gambit-beth-digital-fan-art-mdazcu7vb7ga4sss.jpg",
            video: "",
            imgRandom: "https://images.fineartamerica.com/images/artworkimages/mediumlarge/3/regal-renaissance-cat-portrait-painting-milly-may.jpg",
            message: "✨His Highness Mr. Cat the Fifth 👑",
            likeCount: "50"
        },
        {
            id: 3,
            name: "Otis Milburn",
            published: "October,5 2022 9:AM",
            imgURL: "https://i.pinimg.com/564x/7e/89/c5/7e89c51d342ef0f5fee570eb87165b55.jpg",
            video: "",
            imgRandom: "https://picsum.photos/500/300",
            message: "Curabitur World's Most Beautiful Car In #Test Drive Booking ! The Most Beautiful Car Available In America And The Saudia Arabia, You Can Book Your Test Drive By Our Official Website",
            likeCount: "29"
        },
        {
            id: 4,
            name: "Monica Geller",
            published: "August,24 2022 6:AM",
            imgURL: "https://blogscdn.thehut.net/app/uploads/sites/35/2020/04/everyfriendsoutfit5_1585754531.jpg",
            video: "",
            imgRandom: "https://cdn.pixabay.com/photo/2017/04/23/20/36/tulips-2254970__340.jpg",
            message: "Lorem ipsum",
            likeCount: "76"
        },
        {
            id: 5,
            name: "Emily Cooper",
            published: "September,23 2022 21:PM",
            imgURL: "https://pyxis.nymag.com/v1/imgs/720/78a/c64f539aa5d5cefac27ccd5b1b64e85a91-emily-in-paris.rsquare.w700.jpg",
            video: "",
            imgRandom: "https://media.vogue.co.uk/photos/5f4f9bd2bae3dd1c942e1bdd/master/pass/EIP_101_Unit_00052R.jpg",
            message: "fi post",
            likeCount: "67"
        },
        {
            id: 6,
            name: "Michael Scott",
            published: "October,29 2022 2:AM",
            imgURL: "http://cdn2.hubspot.net/hub/443262/file-2229220199-jpg/20110428_michaelscotttakesabow_photo_main_01.jpg",
            video: "",
            imgRandom: "https://substackcdn.com/image/fetch/f_auto,q_auto:good,fl_progressive:steep/https%3A%2F%2Fbucketeer-e05bbc84-baa3-437e-9518-adb32be77984.s3.amazonaws.com%2Fpublic%2Fimages%2F3bafbb27-cc0e-46fb-b911-6effe823e6f5_759x422.jpeg",
            message: "fth post",
            likeCount: "50"
        },
        {
            id: 7,
            name: "Meredith Grey",
            published: "October,31 2022 18:PM",
            imgURL: "https://pm1.narvii.com/7611/fbbc085a8882aad21bac0d2ff868d05fefec504er1-750-687v2_hq.jpg",
            video: "",
            imgRandom: "https://colorpalettes.net/wp-content/uploads/2017/02/color-palette-3218.png",
            message: "th post",
            likeCount: "28"
        },
        {
            id: 8,
            name: "Sheldon Cooper",
            published: "September,15 2022 19:PM",
            imgURL: "https://i.pinimg.com/280x280_RS/e7/0b/29/e70b29b882a77e6cc259801142c52e20.jpg",
            imgRandom: "https://www.gardeningknowhow.com/wp-content/uploads/2021/08/Orange-fruits.jpg",
            message: "fift",
            likeCount: "10"
        },
        {
            id: 9,
            name: "Mike Wheeler",
            published: "October,15 2022 4:AM",
            imgURL: "https://pbs.twimg.com/media/FEfNHs3VcA0IJnh.jpg",
            video: "",
            imgRandom: "https://static9.depositphotos.com/1719616/1205/i/600/depositphotos_12057489-stock-photo-sunflower-field.jpg",
            message: "fiftt",
            likeCount: "23"
        },
        {
            id: 10,
            name: "Harvey Specter",
            published: "October,15 2022 20:PM",
            imgURL: "https://heroandvillainstyle.com/wp-content/uploads/2020/06/harvey-specter-wardrobe-chalk-stripe-e1591562862946.jpg?ezimgfmt=rs:331x375/rscb4/ngcb4/notWebP",
            video: "",
            imgRandom: "https://www.industrialempathy.com/img/remote/ZiClJf-1920w.jpg",
            message: "fiost",
            likeCount: "26"
        }
    ],
    newPostText: 'Share some of your thoughts here'
}
let currentDate = (new Date()).toString().split(' ').splice(1,3).join(' ');

const newsfeedReducer = (state = initialState, action) => {

    switch (action.type) {
        case ADD_POST: {
            let newPost = {
                id: 0,
                name: "Max Mayfield",
                published: currentDate,
                imgURL: "https://i.pinimg.com/474x/cc/49/e2/cc49e28d907fbd7760e27a8e4142cd3d.jpg",
                message: state.newPostText,
                imgRandom: "https://thumbs.gfycat.com/LameEdibleJohndory-mobile.jpg",
                likeCount: 0
            };
            return  {
                ...state,
                posts: [newPost, ...state.posts],
                newPostText: ''
            };
        }
        case UPDATE_NEW_POST_TEXT: {
            return  {
                ...state,
                newPostText: action.newText
            };
        }
        default:
            return state;
    }
}
export const addPostActionCreator = () => {
    return {
        type: ADD_POST
    }
}
export const updateNewPostTextActionCreator = (text) => {
    return {
        type: UPDATE_NEW_POST_TEXT,
        newText: text
    }
}

export default newsfeedReducer;